// A native-originated room returns a private proof only to its signed-in web
// invitee. Never pass it to the SDK until every request/grant binding matches.
const uuid = value =>
  typeof value === 'string' &&
  /^[a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i.test(value)
export function companyInvitationJoinParams(
  grant,
  { callSid, uid, acceptanceId, now = Date.now() }
) {
  if (!grant || typeof grant.conferenceName !== 'string' || !grant.conferenceName)
    throw new Error('Invite accepted but no conference to join')
  if (grant.nativeInvitation !== true) {
    if (grant.nativeProtocol || grant.webJoinProof || grant.acceptedTransport)
      throw new Error('The invitation response is incomplete; refresh the call')
    return { To: `conference:${grant.conferenceName}`, agentUid: uid }
  }
  const expires = Date.parse(grant.expiresAt)
  const room = /^CA[a-f0-9]{32}$/i.test(callSid || '')
    ? new RegExp(`^call_${callSid}(?:_r\\d+)?$`, 'i').test(grant.conferenceName)
    : /^N[a-f0-9]{31}$/.test(callSid || '') && grant.conferenceName === `call_${callSid}`
  if (
    grant.saved !== true ||
    grant.uid !== uid ||
    grant.callSid !== callSid ||
    grant.acceptanceId !== acceptanceId ||
    !uuid(acceptanceId) ||
    !uuid(grant.claimId) ||
    grant.nativeProtocol !== 'gse-native-company-invites-v1' ||
    grant.acceptedTransport !== 'web' ||
    grant.purpose !== 'invite' ||
    !room ||
    !/^[a-f0-9]{64}$/.test(grant.webJoinProof || '') ||
    !Number.isFinite(expires) ||
    expires <= now ||
    expires > now + 121000
  ) {
    throw new Error('This invitation no longer matches your account, device or call')
  }
  return {
    To: `conference:${grant.conferenceName}`,
    agentUid: uid,
    NativeInvitationId: grant.claimId,
    NativeInvitationProof: grant.webJoinProof,
  }
}
